import { Component } from '@verndale/core';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import { ExtendedWindowType } from '../coveo/engine';

class WarrantyModal extends Component {
  setupDefaults() {
    this.dom = {
      modal: this.el,
      close: this.el.querySelector<HTMLElement>('.modal__close-button'),
    };
  }

  addListeners() {
    (this.dom.close as HTMLButtonElement)?.addEventListener(
      'click',
      this.handleClose.bind(this)
    );
    this.el.addEventListener('click', (e) => {
      if (e.target === this.el) {
        this.handleClose();
      }
    });
  }

  handleClose() {
    (this.dom.modal as HTMLDialogElement)?.close();
    clearAllBodyScrollLocks();

    const global = window as ExtendedWindowType;
    global.dataLayer?.push({
      event: 'modal_close',
      event_category: 'modal overlay',
      event_action: 'close',
      event_attributes: {
        modalName: 'warranties'
      }
    });
  }
}

export default WarrantyModal;
